import { AbstractControl, ValidationErrors } from '@angular/forms';

export function ean13Validator({ value }: AbstractControl): ValidationErrors | null {
  if (value && (value.length !== 13 || isNaN(value))) {
    return { ean13Invalid: true };
  }

  return null;
}
